import * as React from 'react';

interface NavBarProps {
  children?: React.ReactNode;
}

export const NavBar: React.FunctionComponent<NavBarProps> = ({ children }) => {
  return (
    <nav
      data-testid='nav-bar'
      className='hidden h-0 flex sm:block sm:h-auto items-center justify-between flex-wrap transition-all duration-200 border-b-1'
    >
      <div className='flex justify-center px-7 mx-auto'>
        <div className='flex flex-col w-full leading-tight font-effra bg-text-primary-blue sm:space-x-2 justify-between sm:flex-row items-center'>
          {children}
        </div>
      </div>
    </nav>
  );
};
